type TBodyProps = {
  children: React.ReactNode;
};

export const TBody = ({ children }: TBodyProps) => {
  return <tbody>{children}</tbody>;
};
